<template>
  <base-container  ref="container">
    <ArtisanGrid
      ref="resConfig"
      metaKey="ZlResourceDistance"
      @addDistance="addConfig"
      @editDistance="editConfig"
    >
      <template #gridBtnBefore>
        <el-select
          style="margin-right: 5px"
          size="mini"
          @change="changeRes"
          v-model="resource"
          clearable
          placeholder="请选择治疗室"
        >
          <el-option
            v-for="item in resources"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      ref="dialog"
      :title="title"
      width="40%"
      height="40%"
      :visible.sync="isShow"
      v-loading="isLoading"
    >
      <el-form
        ref="dicTypeForm"
        label-width="120px"
        :rules="rules"
        size="mini"
        :model="formData"
      >
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-form-item label="治疗室" prop="resourceId">
              <el-select
                size="mini"
                v-model="formData.resourceId"
                clearable
                :disabled="isEdit"
                placeholder="请选择治疗室"
              >
                <el-option
                  v-for="item in resources"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="对应治疗室" prop="configResId">
              <el-select
                size="mini"
                v-model="formData.configResId"
                clearable
                :disabled="isEdit"
                placeholder="请选择对应治疗室"
              >
                <el-option
                  v-for="item in resources"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="相隔距离" prop="distance">
              <el-input-number
                size="mini"
                :controls="false"
                :min="0"
                v-model="formData.distance"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="save">保存</el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { loadEnums } from "@/api/sys/dicType";
import { add, edit } from "@/api/zl/distance";
export default {
  data() {
    return {
      resources: [],
      resource: "",
      isShow: false,
      isLoading: false,
      title: "新增",
      formData: {
        resourceCode: "",
        resourceId: "",
        configResId: "",
        configResCode: "",
        configResName: "",
        distance: 0,
      },
      isEdit: false,
      rules: {
        resourceId: [
          { required: true, message: "请选择治疗室", trigger: "change" },
        ],
        configResId: [
          { required: true, message: "请选择对应治疗室", trigger: "change" },
        ],
        distance: [
          { required: true, message: "请输入相隔距离", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  created() {
    loadEnums("ZlResourceInfo").then((res) => {
      this.resources = res.data.data.ZlResourceInfo;
    });
  },
  watch: {
    "formData.configResId"() {
      if (this.formData.resourceId != "") {
        if (this.formData.configResId == this.formData.resourceId) {
          this.formData.configResId = "";
          this.$message({
            type: "warning",
            message: "请勿选择相同治疗室！",
          });
        }
      }
    },
    "formData.resourceId"() {
      if (this.formData.configResId != "") {
        if (this.formData.configResId == this.formData.resourceId) {
          this.formData.configResId = "";
          this.$message({
            type: "warning",
            message: "请勿选择相同治疗室！",
          });
        }
      }
    },
  },
  methods: {
    changeRes() {
      this.$refs.resConfig.reload({
        resourceId: this.resource,
      });
    },
    addConfig() {
      this.title = "新增";
      this.formData = {
        resourceCode: "",
        resourceId: this.resource,
        configResId: "",
        configResCode: "",
        configResName: "",
        distance: 0,
      };
      this.$refs.dicTypeForm.resetFields();
      this.isEdit = false;
      this.isShow = true;
    },
    editConfig(row) {
      this.title = "编辑";
      this.formData = Object.assign({}, row);
      this.isEdit = true;
      this.isShow = true;
    },
    save() {
      this.$refs.dicTypeForm.validate((valid) => {
        if (valid) {
          this.$refs.container
            .confirm({
              msg: "确认保存？",
            })
            .then(() => {
              this.isLoading = true;
              if (this.isEdit) {
                edit(this.formData)
                  .then(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.resConfig.reload({
                      resourceId: this.resource,
                    });

                    this.$message({
                      type: "success",
                      message: "编辑成功！",
                    });
                  })
                  .catch(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.resConfig.reload({
                      resourceId: this.resource,
                    });
                  });
              } else {
                add(this.formData)
                  .then(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.resConfig.reload({
                      resourceId: this.resource,
                    });
                    this.$message({
                      type: "success",
                      message: "保存成功！",
                    });
                  })
                  .catch(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.resConfig.reload({
                      resourceId: this.resource,
                    });
                  });
              }
            });
        }
      });
    },
  },
};
</script>

<style>
</style>